export default "__VITE_ASSET__BWmG$mmR__"